import {Field, reduxForm} from 'redux-form/immutable';
import {FormattedMessage, FormattedHTMLMessage, injectIntl, intlShape} from 'react-intl';
import Button from '../../../ui/Button';
import Form from '../../../ui/Form';
import Input from '../../../ui/Input';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styles from '../containers/css/Register.scss';
import connect from "react-redux/es/connect/connect";
import PasswordStrengthMeter from "../../../ui/PasswordStrengthMeter";

/* eslint-disable react/prop-types, react/no-multi-comp */
const renderField = allProps => {

    /* eslint no-unused-vars: ["off", { "ignoreRestSiblings": true }] */
    const {size, ...props} = allProps;

    props.input.id = (props.id || props.input.name);

    return (
        <Form.Control erroneous={!!props.error}>
            {props.label !== false && (
                <Form.Label htmlFor={props.input.name} required={props.required}>
                    <FormattedMessage id={props.label}/>
                </Form.Label>
            )}
            <Input {...props.input} type={props.type}/>
            {props.hint && (
                <Form.Hint>
                    <FormattedMessage id={props.hint}/>
                </Form.Hint>
            )}
            {props.input.name === 'password' && (
                <PasswordStrengthMeter password={props.input.value}/>
            )}
            {props.error && (
                <Form.Error>
                    {props.error}
                </Form.Error>
            )}
        </Form.Control>
    );
};


const validate = values => {
    const errors = {};

    const email = values.get('email');

    if (email && !email.length) {
        errors.email = 'Required';
    }
    return errors;
};

@injectIntl
export class RegisterForm extends Component {
    /* eslint-enable */
    static propTypes = {
        intl: intlShape,
        handleSubmit: PropTypes.func,
        submitting: PropTypes.bool,
    }

    render() {
        const {handleSubmit, submitting, validationData} = this.props;

        const submitErrors = validationData.getIn(['account', 'register', 'submitErrors']);

        return (
            <Form onSubmit={handleSubmit}>
                <Form.Fieldset>
                    <h3>
                        <FormattedMessage id='frontend.form_register.headline'/>
                    </h3>

                    <Form.Row>
                        <Field
                            name='name'
                            label='frontend.form_register.label.name'
                            component={renderField}
                            type='name'
                            required
                            props={{disabled: submitting}}
                            error={submitErrors && submitErrors.get('name')}
                        />
                    </Form.Row>

                    <Form.Row>
                        <Field
                            name='email'
                            label='frontend.form_register.label.email'
                            component={renderField}
                            type='email'
                            required
                            props={{disabled: submitting}}
                            error={submitErrors && submitErrors.get('email')}
                        />
                    </Form.Row>
                    <Form.Row>
                        <Field
                            name='password'
                            label='frontend.form_register.label.password'
                            component={renderField}
                            type='password'
                            required
                            props={{disabled: submitting}}
                            error={submitErrors && submitErrors.get('password')}
                        />
                    </Form.Row>
                    <Form.Row>
                        <Field
                            name='password_confirmation'
                            label='frontend.form_register.label.password_confirm'
                            component={renderField}
                            type='password'
                            required
                            props={{disabled: submitting}}
                            error={submitErrors && submitErrors.get('password')}
                        />
                    </Form.Row>
                    <Form.Row>
                        <Field
                            component='input'
                            id='lpr_terms'
                            name='accept_lpr_terms'
                            type='checkbox'
                            props={{disabled: submitting}}
                        />
                        {' '}
                        <label htmlFor='remember'>
                            <FormattedHTMLMessage
                                id='frontend.form_register.label.accept_lpr_terms'
                            />
                        </label>
                        {submitErrors && <div className={styles.checkbox}>{submitErrors.get('acceptLprTerms')}</div>}
                    </Form.Row>
                    <div className={styles.or}>
                        <FormattedMessage
                            id='frontend.form_register.divider.or'/>
                    </div>
                    <Form.Row>
                        <Field
                            component='input'
                            id='tenant_terms'
                            name='accept_tenant_terms'
                            type='checkbox'
                            props={{disabled: submitting}}
                        />
                        {' '}
                        <label htmlFor='remember'>
                            <FormattedMessage
                                id='frontend.form_register.label.accept_tenant_terms'
                            />
                        </label>
                        {submitErrors && <div className={styles.checkbox}>{submitErrors.get('acceptTenantTerms')}</div>}
                    </Form.Row>
                    <Form.Row>
                        <Field
                            component='input'
                            id='privacy_protection'
                            name='accept_privacy_protection'
                            type='checkbox'
                            props={{disabled: submitting}}
                        />
                        {' '}
                        <label htmlFor='remember'>
                            <FormattedHTMLMessage
                                id='frontend.form_register.label.accept_privacy_protection'
                            />
                        </label>
                        {submitErrors &&
                        <div className={styles.checkbox}>{submitErrors.get('acceptPrivacyProtection')}</div>}
                        <br/><br/>
                        <FormattedMessage
                            id='frontend.form_register.text'
                        />
                    </Form.Row>
                </Form.Fieldset>

                <Button emphasis='primary' type='submit' block disabled={submitting}>
                    <FormattedMessage id='frontend.form_register.button.register'/>
                </Button>
            </Form>
        );
    }
}

let FormComponent = reduxForm({
    form: 'account.register',
    validate,
})(RegisterForm);

FormComponent = connect(state => ({
    validationData: state.form,
}))(FormComponent);


// See https://github.com/erikras/redux-form/issues/1010
export default {
    Component: FormComponent,
};
